// Thin logging wrapper. Shaped to match the Sentry API so integrating it later
// is a one-line change per method — just uncomment the Sentry calls below.
//
// To add Sentry:
//   npm install @sentry/react
//   import * as Sentry from "@sentry/react";
//   Then replace the console.* calls with Sentry.captureException / captureMessage.

const isProd = process.env.NODE_ENV === "production";

export const logger = {
  /**
   * Log unexpected errors. Always writes — even in production — because without
   * a remote sink there's no other way to spot failures.
   * @param {string} message
   * @param {unknown} [extra]
   */
  error(message, extra) {
    console.error("[ecogynize:error]", message, extra ?? "");
    // Sentry.captureException(extra instanceof Error ? extra : new Error(message), { extra });
  },

  /** Warnings — dev only to keep the production console clean. */
  warn(message, extra) {
    if (!isProd) console.warn("[ecogynize:warn]", message, extra ?? "");
    // Sentry.captureMessage(message, { level: "warning", extra });
  },

  /** Informational — dev only. */
  info(message, extra) {
    if (!isProd) console.info("[ecogynize:info]", message, extra ?? "");
  },
};
